export const NAVIGATION_EVENTS = Object.freeze({
  APP_NAVIGATION_CLICKED: {
    name: 'app_navigation_clicked',
    category: 'Navigation',
    description: 'App 内导航入口点击时触发',
    requiredParams: [],
    optionalParams: [
      'event_label', 'module_name', 'source', 'source_position',
      'element_name', 'element_type', 'target_route_name', 'target_route_type',
      'method', 'lang', 'is_logged_in'
    ]
  },
  LANGUAGE_CHANGED: {
    name: 'language_changed',
    category: 'Navigation',
    description: '语言切换时触发',
    requiredParams: [],
    optionalParams: ['from_lang', 'to_lang', 'source']
  },
  // 注：早期曾定义 LOGO_CLICKED（logo_clicked），但其唯一可选字段是裸 `source`
  // （与《埋点字典》§5 禁止裸 source 的约定冲突，且未在 §1 全局字段表登记），
  // 且无任何调用方。Logo 点击已统一并入 APP_NAVIGATION_CLICKED（element_name='logo'），
  // 故该事件已删除，不再保留空事件占位。
  UI_PREFERENCE_CHANGED: {
    name: 'ui_preference_changed',
    category: 'Navigation',
    description: '全局 UI 偏好设置变化时触发',
    requiredParams: ['option_name', 'option_value'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name',
      'element_type', 'method', 'previous_value', 'lang', 'is_logged_in'
    ]
  }
});
